import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";
import {WidgetType} from "../models/widget";

const getUrl = (): string => {
  return `http://45.94.254.153:8042/quizzes`;
};

function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    delete: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.delete(url, {});
    },
    
    getItem: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${params.id}`
      return HttpRequest.get(url);
    },
    
    create: (data: RequestData) => {
      return HttpRequest.post(`${getUrl()}`, data.payload, {});
    },
    
    update: (data: RequestData) => {
      return HttpRequest.put(
        `${getUrl()}/${getPropByString(data, "params.id")}`,
        data.payload,
        {}
      );
    },
    
    updateOrder: (data: RequestData) => {
      return HttpRequest.post(`${getUrl()}/order/`, data.payload, {});
    },
  
    addContentListItems: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/video-contents`;
      return HttpRequest.post(url, data.payload, {});
    },
  
    deleteContentListItems: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}/video-contents`;
      return HttpRequest.delete(url, {
        data: data.payload
      });
    },
  
    getQuestions: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.quiz_id")}/questions`
      return HttpRequest.get(url, {
        params: params
      });
    },
  };
}

export default api();
